import styled from '@emotion/styled';

const View = styled.div({});

export default View;
